import footerBg from "../assets/images/footer.webp";
import companyLogo from "../assets/images/gypsycompanion.jpeg"; // Add your company logo


import "../assets/css/style.css";
import "../assets/css/footer.css";

function Footer() {
  return (
    <footer
      className="site-footer mt-5"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="container">

        <div className="row text-center text-md-start">
          {/* Part 1: Company Logo, Details & Address */}
          <div className="col-12 col-md-6 col-lg-4  mb-4">
            <div className="footer-about">
              <img
                src={companyLogo}
                alt="Company Logo"
                className="footer-logo mb-3"
                style={{ maxWidth: "114px", height: "auto" }}
              />
              <p className="company-description">
                Your trusted travel partner for amazing adventures and spiritual journeys.
                We create unforgettable experiences that last a lifetime.
              </p>
              {/* <div className="company-address mt-3">
                <h4 className="address-title">Our Office</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> 123, Travel Street,<br />
                  Andheri East, Mumbai - 400093,<br />
                  Maharashtra, India
                </p>
              </div> */}
            </div>
          </div>

          {/* Part 2: Quick Links */}
          <div className="col-12 col-md-6 col-lg-4  mb-4">
            <div className="footer-links">
              <h2 className="footer-heading mb-4 text-center quick">Quick Links</h2>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4  "></div>
                <div className="col-12 col-md-6 col-lg-4 ">
                  <ul className="list-unstyled">
                    <li><a href="/">🏠 Home</a></li>
                    <li><a href="/about">📖 About Us</a></li>
                    <li><a href="/tour">✈️ Tours</a></li>
                    <li><a href="/contact">📞 Contact</a></li>

                  </ul>
                </div>
                <div className="col-12 col-md-6 col-lg-4  mb-4">
                </div>

                {/* <div className="col-md-6">
                  <ul className="list-unstyled">

                    <li><a href="/privacy-policy">🔒 Privacy Policy</a></li>

                    <li><a href="/terms">📜 Terms & Conditions</a></li>
                    <li><a href="/faq">❓ FAQ</a></li>
                    <li><a href="/blog">📝 Blog</a></li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>

          {/* Part 3: Contact Info & Social Media */}
          <div className="col-12 col-md-6 col-lg-4  mb-4">
            <div className="footer-contact">
              <h2 className="footer-heading mb-4">Contact Us</h2>

              <div className="contact-info">
                <div className="contact-item mb-3">
                  <i className="fas fa-phone-alt"></i>
                  <strong>Phone:</strong><br />
                  <a href="tel:+919689938912">+91 9689938912</a><br />
                  <a href="tel:+918484037008">+91 8484037008</a>




                </div>

                <div className="contact-item mb-3">
                  <i className="fas fa-envelope"></i>
                  <strong>Email:</strong><br />
                  <a href="mailto:gypsycompanion@gmail.com">gypsycompanion@gmail.com</a><br />
                </div>

                {/* <div className="contact-item mb-3">
                  <i className="fas fa-clock"></i>
                  <strong>Business Hours:</strong><br />
                  Monday - Saturday: 10:00 AM - 7:00 PM<br />
                  Sunday: Closed
                </div> */}
              </div>

            </div>
          </div>
        </div>

        {/* Social Icons ABOVE copyright */}
        <div className="icons justify-content-center mb-3">
          <a href="https://www.facebook.com/gypsyninad/" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>

          <a href="https://www.instagram.com/ninad_gypsy/" target="_blank" rel="noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          {/* 
          <a href="https://twitter.com/yourpage" target="_blank" rel="noreferrer">
            <i className="fab fa-twitter"></i>
          </a>

          <a href="https://youtube.com/yourpage" target="_blank" rel="noreferrer">
            <i className="fab fa-youtube"></i>
          </a>

          <a href="https://linkedin.com/company/yourpage" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a> */}

          <a href="https://wa.me/919689938912" target="_blank" rel="noreferrer">
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>

        {/* Copyright Section with Social Media */}
        <div className="row pt-4 text-center">
          <div className="col-md-12">
            <div className="border-top pt-4">



              <p className="copyright-text">
                © {new Date().getFullYear()} All Rights Reserved |&nbsp;
                <a
                  href="https://www.marketingintelligence.tech/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#a2f44a", textDecoration: "none" }}
                >
                  Powered by MI Tech Solutions
                </a>
              </p>
            </div>
          </div>
        </div>

      </div>

    </footer>
  );
}

export default Footer;